import { IProfit } from '@zc/api';

export interface ICompanyRelationship {
  companyId: string;
  vendorId: string;
  margins: IProfit[];
}
